import { createStyles, Grid, TextField, Theme, withStyles, WithStyles } from '@material-ui/core'
import * as React from 'react'

interface WeeklyHoursProps extends WithStyles<typeof styles> {
	required?: boolean
	jobPlacementWeeklyHours?: number
	onHoursChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const WeeklyHours: React.FC<WeeklyHoursProps> = (props: WeeklyHoursProps) => {
	const { classes, jobPlacementWeeklyHours, onHoursChange, required } = props

	return (
		<Grid container={true} spacing={8}>
			<Grid item={true} xs={12} md={3} className={classes.dropdownLabel}>
				Weekly Hours&#58;{ props.required === true && (<span className={classes.requiredField} >*</span> ) }
			</Grid>
			<Grid item={true} xs={6} sm={4}>
				<TextField
					name="jobPlacementWeeklyHours"
					required={required}
					className={classes.dropdown}
					value={jobPlacementWeeklyHours || ''}
					onChange={onHoursChange}
					margin="dense"
					variant="outlined"
					InputProps={{
						inputProps: {
							type: 'number',
							min: '0',
							step: '0.01',
						},
					}}
				/>
			</Grid>
		</Grid>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		dropdownLabel: {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'center',
			paddingTop: '12px',
			[theme.breakpoints.down('sm')]: {
				justifyContent: 'flex-start',
			},
		},
		dropdown: {
			display: 'flex',
			flex: 1,
		},
    requiredField:{
      color:'red'
    }
	})

export default withStyles(styles)(WeeklyHours)
